import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { api_url } from '../../constants.helper';
import { handleError } from '../../utils/error.handler';

@Injectable({
  providedIn: 'root',
})
export class OtpService {
  constructor(private httpClient: HttpClient) {}

  validateLandingUser(requestBody: any, apiDomain: string, client_id: string) {
    return this.httpClient
      .post<any>(apiDomain + api_url.LANDING_VALIDATION, requestBody, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          client_id,
        }),
      })
      .pipe(
        map((response) => response.data),
        catchError((e) => throwError(() => handleError(e).message))
      );
  }

  generateOTP(requestBody: any, apiDomain: string, client_id: string) {
    return this.httpClient
      .post<any>(apiDomain + api_url.OTP_REGISTER, requestBody, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          client_id,
        }),
      })
      .pipe(
        map((response) => response.data),
        catchError((e) => throwError(() => handleError(e).message))
      );
  }

  verifyToken(
    requestBody: any,
    apiDomain: string,
    client_id: string,
    otptoken: string
  ) {
    return this.httpClient
      .post<any>(apiDomain + api_url.OTP_VERIFY, requestBody, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          client_id,
          otptoken,
        }),
      })
      .pipe(
        map((response) => response.data),
        catchError((e) => {
          const errorCode = handleError(e).code;
          if (errorCode === 'INVALIDCODE') {
            const newToken = e.error.errors[0].otptoken;
            return throwError(() => ({
              newToken,
              message: handleError(e).message,
            }));
          } if (errorCode === 'MAXATTEMPTSREACHED') {
            return throwError(() => ({
              code: 'MAXATTEMPTSREACHED',
              message: handleError(e).message,
            }));
          }
          return throwError(() => handleError(e).message);
        })
      );
  }
}
